import http from '@/utils/http';

export default {
	recordsListAll: data => {
		return http({ url: '/api/admin/v3/purchaseRecords/listAll' ,data}).then(r => r);
	},
	productBySessionCode: data => {
		return http({ url: '/api/admin/v3/purchaseRecords/productBySessionCode', data }).then(r => r);
	},
	generatePurchase: data => {
		return http({ url: '/api/admin/v3/purchase/generatePurchase', data ,loading: true,tip:true}).then(r => r);
	},
	// V3 异步生成采购单（带进度条）
	generatePurchaseAsync: data => {
		return http({ url: '/api/admin/v3/purchase/generatePurchaseAsync', data }).then(r => r);
	},
	update: data => {
		return http({ url: '/api/admin/v2/purchase/update', data ,loading: true,tip:true}).then(r => r);
	},
	batchUpdate: data => {
		return http({ url: '/api/admin/v2/purchase/batchUpdate', data ,loading: true,tip:true}).then(r => r);
	},
	// 获取未发货统计数量（24h/48h/超48h）
	getDeliveryStats: () => {
		return http({ url: '/api/admin/v3/purchase/getDeliveryStats' }).then(r => r);
	},
	// 获取未发货采购单列表（按类型）
	getDeliveryStatsList: data => {
		return http({ url: '/api/admin/v3/purchase/getDeliveryStatsList', data }).then(r => r);
	}
};